export default __webpack_public_path__ + "static/media/reports-8.b5a3dc24.png";